import { render, staticRenderFns } from "./delDialog.vue?vue&type=template&id=213b3e30&scoped=true"
import script from "./delDialog.vue?vue&type=script&lang=js"
export * from "./delDialog.vue?vue&type=script&lang=js"
import style0 from "./delDialog.vue?vue&type=style&index=0&id=213b3e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213b3e30",
  null
  
)

export default component.exports